import { Component } from '@angular/core';
import { PipesModule } from '../../pipes/pipes.module';

@Component({
	selector: 'app-sso-waiting',
	standalone: true,
	imports: [PipesModule],
	templateUrl: './sso-waiting.component.html',
	styleUrl: './sso-waiting.component.scss'
})
export class SsoWaitingComponent {

}
